// src/components/intake/IntakeShell.jsx
//
// The print intake's page frame: a purple masthead with the step's eyebrow,
// title and intro, then a 760px column. The global <Navbar /> stays above it
// (these routes are not in OWN_NAV_ROUTES), the same arrangement as the
// Template Gallery.

import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { tokens } from '../../theme';
import { eyebrowSx } from '../manuscript/structureTokens';
import { SP, FONT } from './intakeSx';

export default function IntakeShell({ eyebrow, title, intro, aside, onBack, backLabel = 'Back', children }) {
  return (
    // `100%`, not `100vh`: <main> already grows to fill what the Navbar and
    // Footer leave. See TemplateGallery.jsx.
    <Box sx={{ background: SP.lavender, minHeight: '100%' }}>
      <Box sx={{ background: SP.purpleDeep, color: SP.white, px: { xs: '16px', sm: '24px' }, pt: '20px', pb: '30px' }}>
        <Box sx={{ maxWidth: 760, mx: 'auto' }}>
          {onBack && (
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={onBack}
              sx={{
                color: tokens.color.onDark,
                fontSize: 13,
                textTransform: 'none',
                px: 0,
                '&:hover': { color: SP.goldLight, background: 'transparent' },
              }}
            >
              {backLabel}
            </Button>
          )}
          <Box sx={{ ...eyebrowSx, color: SP.goldLight, mt: onBack ? 2 : 0 }}>{eyebrow}</Box>
          <Typography
            component="h1"
            sx={{
              fontFamily: FONT.serif,
              fontWeight: 600,
              color: SP.white,
              fontSize: 'clamp(24px, 4vw, 32px)',
              mt: '10px',
              maxWidth: '26ch',
              textWrap: 'balance',
              overflowWrap: 'anywhere',
            }}
          >
            {title}
          </Typography>
          {intro && (
            <Typography sx={{ color: tokens.color.onDark, fontSize: 14, mt: '10px', maxWidth: '58ch' }}>
              {intro}
            </Typography>
          )}
          {aside}
        </Box>
      </Box>
      <Box sx={{ maxWidth: 760, mx: 'auto', px: { xs: '16px', sm: '24px' }, pb: '90px' }}>{children}</Box>
    </Box>
  );
}
